import api from "../../helpers/api";


export const getApplicants = (body) => api.post('/applicant/search-applicants', {...body})

export const getApplicant = (id) => api.get(`/applicant/${id}`)

// export const createApplicant = (formData) => api.post('artisan' , {...formData})
export const createApplicant = (formData) => api.post('applicant/add' , {...formData})

export const updateApplicant = (id , formData) => api.put(`applicant/update/${id}` , {...formData})

// export const updateApplicant = (id , formData) => api.put(`/artisan-staging/` , {id,...formData})

export const deleteApplicant = (id) => api.delete(`applicant/${id}`)


